// Copyright ©️ 2026 eVolve MEP, LLC

import { useEffect } from 'react';

import { type QrCodeId, useEvolveGet } from '@evolvemep/api-ts';
import { LoadingOverlay } from '@mantine/core';
// oxlint-disable-next-line no-restricted-imports
import { useParams, useNavigate } from 'react-router';

export const QrCodeRedirectPage = () => {
  const navigate = useNavigate();
  const { qrCodeId } = useParams();

  const { apiCall: getQrCode } = useEvolveGet('shop/qrCode/:qrCodeId');

  useEffect(() => {
    if (!qrCodeId) {
      void navigate('/', { replace: true });
      return;
    }

    void getQrCode({ url: `shop/qrCode/${qrCodeId as QrCodeId}` })
      .then((response) => window.location.replace(response.url))
      .catch(() => navigate('/', { replace: true }));
  }, [qrCodeId, getQrCode, navigate]);

  return <LoadingOverlay visible />;
};
